import { SiteIdOverrideConfig } from "stores/wizard/config";
import { DayName } from "uitk-react-new-date-picker";

export const siteId69: SiteIdOverrideConfig = {
  global: {
    heroImageSrc: "https://a.travel-assets.com/travel-assets-manager/cmct-2428/LATAM_Winter_1400x600.jpg",
  },
  hotel: {
    date: {
      firstDayOfWeek: DayName.SUN,
    },
  },
  flight: {
    date: {
      firstDayOfWeek: DayName.SUN,
    },
  },
  package: {
    date: {
      firstDayOfWeek: DayName.SUN,
    },
  },
  car: {
    date: {
      firstDayOfWeek: DayName.SUN,
    },
  },
  lx: {
    date: {
      firstDayOfWeek: DayName.SUN,
    },
  },
};
